import moment from 'moment';
import { getData } from '@/components/report/service';
import GenerateCondit from '@/models/GenerateCondit';
import { CALCWEIGHT } from '@/models/GenerateCondit/Interrelated';
import RouteEntity from '@/Entity/RouteEntity';
import { computeWeight } from '@/utils/query';
import {
  GetOrganizationAuth,
  GetProvinceAreaAuth,
  GetTableDate,
  getBelongCenterForOperatingArea,
} from '@/services/area';

const getDefaultDates = () => {
  const now = moment();
  const currentHour = now.hour();

  if (currentHour < 9) {
    // 9:00 前：开始和结束日期为"当日-2"
    const targetDate = now.add(-2, 'days').format('YYYY-MM-DD');
    return {
      startDate: targetDate,
      endDate: targetDate,
    };
  } else {
    // 9:00 后：开始和结束日期为"当日-1"
    const targetDate = now.add(-1, 'days').format('YYYY-MM-DD');
    return {
      startDate: targetDate,
      endDate: targetDate,
    };
  }
};

const paramsForm = {
  ...getDefaultDates(),
  productType: [
    '定时达',
    '精准零担',
    'MINI电商大件',
    'MINI电商小件',
    '普惠达',
    '安心达',
    '填仓',
    '整车',
  ],
  goodsType: '全部',
};

export default {
  namespace: 'ProvinceCargoVolumeMatrixSr',
  state: {
    filter: { ...paramsForm },
    tableColumns: [], // table header
    destinationProvinceAreas: [], // 目的省份
    tableItem: [],
    tableOffsetHeight: 0,
    tableItem1: [],
    tableColumns1: [],
  },
  effects: {
    *getTableDate(_, { put, select }) {
      const query = yield select(({ ProvinceCargoVolumeMatrixSr }) => {
        return {
          startTime: ProvinceCargoVolumeMatrixSr.filter.startDate + ' 09:00:00',
          endTime:
            moment(ProvinceCargoVolumeMatrixSr.filter.endDate).add(1, 'days').format('YYYY-MM-DD') +
            ' 09:00:00',
          productType: ProvinceCargoVolumeMatrixSr.filter.productType,
          goodsType: ProvinceCargoVolumeMatrixSr.filter.goodsType,
        };
      });
      const gc = new GenerateCondit({
        dataSource: 'actual_load_unload_result',
        dimensions: ['originProvinceArea', 'destinationProvinceArea'],
        aggregators: [CALCWEIGHT],
        startDate: query.startTime + ' 09:00:00',
        endDate: query.endTime + ' 09:00:00',
      });
      const provinceArea = yield GetProvinceAreaAuth();
      const originProvinceAreaEntity = new RouteEntity({
        scanType: '录单',
        productType: query.productType,
        originProvinceArea: provinceArea?.name,
        [query.goodsType]: query.goodsType === 'goodsType' ? '网络' : '',
      });
      const destinationProvinceAreaEntity = new RouteEntity({
        scanType: '录单',
        productType: query.productType,
        destinationProvinceArea: provinceArea?.name,
        [query.goodsType]: query.goodsType === 'goodsType' ? '网络' : '',
      });
      const originProvinceAreaParams = gc.converCondit(originProvinceAreaEntity);
      const destinationProvinceAreaParams = gc.converCondit(destinationProvinceAreaEntity);
      if (query.goodsType === 'originSite') {
        originProvinceAreaParams.likeFilters = [{ key: 'originSite', value: '^*T' }];
        destinationProvinceAreaParams.likeFilters = [{ key: 'originSite', value: '^*T' }];
      }
      const originProvinceAreaData = yield getData(originProvinceAreaParams);
      let allData = originProvinceAreaData,
        destinationProvinceAreaData;
      if (!!provinceArea) {
        destinationProvinceAreaData = yield getData(destinationProvinceAreaParams);
        allData = originProvinceAreaData.concat(destinationProvinceAreaData);
      }

      const str = JSON.stringify(allData);
      const replaceStr = str.replace(/分拨中心|经营本部|省区|营运区|管理区/g, '');
      allData = JSON.parse(replaceStr);

      const tableItem = [], // 数据
        tableColumns = [], // 表头
        lastContent = {
          // 数据合记
          originProvinceArea: '合计',
          rok: -1,
        };
      allData.forEach((it, rok) => {
        // 构建表头
        if (!tableColumns.find((item) => it.destinationProvinceArea === item.title)) {
          if (it.destinationProvinceArea) {
            tableColumns.push({
              width: 60,
              align: 'center',
              title: it.destinationProvinceArea,
              dataIndex: it.destinationProvinceArea,
            });
          }
        }

        const findItemIndex = tableItem.findIndex(
          (item) => item.originProvinceArea === it.originProvinceArea,
        );
        const calcweight = computeWeight(it.calcWeight, 1);
        if (findItemIndex > -1) {
          tableItem[findItemIndex][it.destinationProvinceArea] = calcweight;
          tableItem[findItemIndex].result =
            (tableItem[findItemIndex].result + calcweight).toFixed(1) - 0;
        } else {
          tableItem.push({
            rok,
            originProvinceArea: it.originProvinceArea,
            [it.destinationProvinceArea]: calcweight,
            result: calcweight,
          });
        }
        // 合计
        if (lastContent.result === undefined) {
          lastContent.result = calcweight;
        } else {
          lastContent.result = (lastContent.result + calcweight).toFixed(1) - 0;
        }
        if (lastContent[it.destinationProvinceArea] === undefined) {
          lastContent[it.destinationProvinceArea] = calcweight;
        } else {
          lastContent[it.destinationProvinceArea] =
            (lastContent[it.destinationProvinceArea] + calcweight).toFixed(1) - 0;
        }
      });
      // ------/
      tableColumns.unshift({
        width: 80,
        title: '始发-目的',
        fixed: 'left',
        align: 'center',
        dataIndex: 'originProvinceArea',
      });
      tableColumns.push({
        width: 70,
        title: '合计',
        fixed: 'right',
        align: 'center',
        dataIndex: 'result',
        // render: record => {
        //   return <span>{record.toFixed(1)}</span>;
        // },
      });
      tableItem.push(lastContent);
      // originProvinceArea-起始  destinationProvinceArea-目的  calcWeight-值
      yield put({
        type: 'update',
        payload: {
          tableColumns,
          tableItem: tableItem.filter((it) => it.originProvinceArea),
        },
      });
    },
    *newgetTableDate(_, { call, put, select }) {
      const auth = yield GetOrganizationAuth();
      const { filter } = yield select(
        ({ ProvinceCargoVolumeMatrixSr }) => ProvinceCargoVolumeMatrixSr,
      );
      let provinceAreaNameList;
      if (auth.isHead) {
        provinceAreaNameList = undefined;
      }
      if (auth.isArea) {
        provinceAreaNameList = (auth.provinces || []).map((item) => item.label);
      }
      if (auth.isCenter) {
        const provinces = yield getBelongCenterForOperatingArea([auth.name]);
        if (provinces) {
          let result = Array.from(provinces.values());
          provinceAreaNameList = (result && result.map((item) => item.provinceAreaName)) || [];
        }
      }
      const params = {
        startDate: filter.startDate + ' 09:00:00',
        endDate: moment(filter.endDate).add(1, 'days').format('YYYY-MM-DD') + ' 09:00:00',
        productTypes: filter.productType,
        goodsType: filter.goodsType,
        provinceAreaNameList,
        dataType: 1,
      };
      const data = yield call(GetTableDate, params);
      let columns = Object.keys(data[0]).map((item) => {
        const newItem = {
          dataIndex: item,
          title: item,
          align: 'center',
          width: 60,
        };
        if (item === '始发-目的') {
          newItem.fixed = 'left';
          newItem.width = 90;
        }
        if (item === '合计') {
          newItem.fixed = 'right';
          newItem.width = 80;
        }
        return newItem;
      });
      yield put({
        type: 'update',
        payload: {
          tableColumns1: columns,
          tableItem1: data.map((item, index) => ({ ...item, rok: index })),
        },
      });
    },
  },
  reducers: {
    update(state, { payload }) {
      return { ...state, ...payload };
    },
  },
};
